var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"m-1 text-sm border hover:text-primary text-text1 rounded-xl filter_list_btn bottom_space",class:`${_vm.isActive ? 'bg-info border-info' : 'bg-white border-gray2'}
  ${_vm.btnSize === 'medium' ? 'py-2 px-4' : ''}
  ${_vm.btnSize === 'large' ? 'py-2.5 px-4' : ''}
  ${_vm.btnSize === 'small' ? 'py-1.5 px-3' : ''}
  `,on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.buttonHandler.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }